import ajaxPagination from "./ajaxPagination";
import { getSearchParam } from "../functions";

const ajaxListData = (data) => {
  var j = 0;
  var total = 0;
  const resultSection = document.getElementById("archive-loop-section");
  if (data.results.length > 0 && Array.isArray(data.results)) {
    data.results.forEach((item) => {
      resultSection.innerHTML += item;
    });
  } else {
    resultSection.innerHTML = '<div class="container"><p>No results found.</p></div>';
  }

  if (data.results) {
    total = data.results.length;
  }

  let searchMessage = document.getElementById("search-message-title");
  if (searchMessage) {
    const label = total == 1 ? "Risultato" : "Risultati";
    searchMessage.innerHTML = total + " " + label + ' per: "' + getSearchParam() + '"';
  }

  if (document.querySelector(".pagination-section")) {
    ajaxPagination(j);
  }
};

export default ajaxListData;
